import { Alert } from './alert';

export class AlertPage {
  items: Alert[];
  nextPageToken: string;
}
